var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8629 5.44582L13.9533 1.77064C13.3427 1.51877 12.6573 1.51877 12.0467 1.77064L3.13714 5.44582C2.09137 5.8772 1.46559 6.95707 1.61129 8.07889L2.6299 15.9222C2.87946 17.8439 3.86315 19.5944 5.37479 20.8068L11.4358 25.6683C12.3498 26.4013 13.6502 26.4013 14.5642 25.6683L13.6257 24.4981L14.5642 25.6683L20.6252 20.8068C22.1369 19.5944 23.1205 17.8439 23.3701 15.9222L24.3887 8.07889C24.5344 6.95707 23.9086 5.8772 22.8629 5.44582Z",
    stroke: "#F89500",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14L12.4184 17.545C12.6424 17.7773 13.0244 17.7398 13.1989 17.4683L18 10",
    stroke: "#F89500",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.822f8475f81486d0bcdb3fed2a053dcc.svg";
export { ForwardRef as ReactComponent };